import PreventScroll from '../modules/preventScroll';

class Header {
    constructor() {
        if (document.querySelector('.header')) {
            this.opener = document.getElementById('js-open-menu');
            this.closer = document.getElementById('js-close-menu');

            this.items = document.querySelector('.header__items');
            this.backs = document.querySelectorAll('.header__back');

            this.opener.addEventListener('click', () => {
                this.open();
            });
            this.closer.addEventListener('click', () => {
                this.close();
            });
            this.items.addEventListener('click', (e) => {
                this.openSub(e);
            });
            this.backs.forEach((back) => {
                back.addEventListener('click', () => {
                    this.closeSub();
                });
            });

            Header.manageFilter();
        }
    }

    open() {
        window.dispatchEvent(new CustomEvent('openMenu'));
        const { items, closer } = this;
        closer.classList.replace('hidden', 'block');
        items.classList.replace('hidden', 'flex');
        items.classList.add('active-anim');

        setTimeout(() => {
            [items, closer].forEach((elem) => {
                elem.classList.add('active');
            });
        }, 5);

        PreventScroll.disableScroll();
    }

    close() {
        window.dispatchEvent(new CustomEvent('closeMenu'));
        const { items, closer } = this;
        [items, closer].forEach((elem) => {
            elem.classList.remove('active');
        });

        items.style.left = null;

        setTimeout(() => {
            closer.classList.replace('block', 'hidden');
            items.classList.replace('flex', 'hidden');
            items.classList.remove('active-anim');
            document.querySelectorAll('.header__subitems').forEach((sub) => {
                sub.classList.remove('active', 'hidden');
            });
        }, 300);

        PreventScroll.enableScroll();
    }

    openSub(e) {
        const { target } = e;
        if (window.innerWidth >= 992) return;

        if (
            !target.classList.contains('header__link')
            && !target.parentNode.classList.contains('header__link')
        ) return;

        if (!target.parentNode.parentNode.querySelector('.header__subitems')) return;

        e.preventDefault();
        const link = target.classList.contains('header__link') ? target : target.parentNode;

        const subitem = link.parentNode.querySelector('.header__subitems');
        if (subitem) {
            const subs = this.items.querySelectorAll('.header__subitems');
            subs.forEach((sub) => {
                sub.classList.add(sub === subitem ? 'active' : 'hidden');
            });
        }
        this.items.style.left = '-100%';
    }

    closeSub() {
        this.items.style.left = null;
        document.querySelectorAll('.header__subitems').forEach((sub) => {
            sub.style.left = "100%"; // eslint-disable-line

            setTimeout(() => {
                sub.classList.remove('active', 'hidden');
                sub.style.left = null; // eslint-disable-line
            }, 300);
        });
    }

    static manageFilter() {
        const header = document.querySelector('.header');
        const headerFilter = document.querySelector('.header__filter');
        header.addEventListener('mouseenter', () => {
            headerFilter.style.opacity = '.8';
        });
        header.addEventListener('mouseleave', () => {
            headerFilter.style.opacity = '0';
        });
    }
}
export default Header;
